/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallenge } from './LadderChallenge';
import {
    LadderChallengeFromJSON,
    LadderChallengeFromJSONTyped,
    LadderChallengeToJSON,
    LadderChallengeToJSONTyped,
} from './LadderChallenge';

/**
 * 
 * @export
 * @interface AcceptLadderChallengeResponse
 */
export interface AcceptLadderChallengeResponse {
    /**
     * 
     * @type {LadderChallenge}
     * @memberof AcceptLadderChallengeResponse
     */
    challenge: LadderChallenge;
}

/**
 * Check if a given object implements the AcceptLadderChallengeResponse interface.
 */
export function instanceOfAcceptLadderChallengeResponse(value: object): value is AcceptLadderChallengeResponse {
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    return true;
}

export function AcceptLadderChallengeResponseFromJSON(json: any): AcceptLadderChallengeResponse {
    return AcceptLadderChallengeResponseFromJSONTyped(json, false);
}

export function AcceptLadderChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptLadderChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': LadderChallengeFromJSON(json['challenge']),
    };
}

export function AcceptLadderChallengeResponseToJSON(json: any): AcceptLadderChallengeResponse {
    return AcceptLadderChallengeResponseToJSONTyped(json, false);
}

export function AcceptLadderChallengeResponseToJSONTyped(value?: AcceptLadderChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': LadderChallengeToJSON(value['challenge']),
    };
}

